import { isPotentialOffering, LiveDataOffering, PotentialOffering } from 'types'

export function getPortfolioId(portfolio: LiveDataOffering | PotentialOffering) {
  return isPotentialOffering(portfolio) ? portfolio.id.toString() : portfolio.address
}
